import { cx } from '@emotion/css';
import { ElementType, isValidElement } from 'react';
import { MetaNavMenuItemProps } from '../types/navigation.types';
import { useNavigation } from '../context/navigation-context-provider';
import { getRelativeUrl } from '../helpers/utils';
import styles from '../navigation.module.scss';

export const MetaNavItem = <C extends ElementType>(props: MetaNavMenuItemProps<C>) => {
  const { setState } = useNavigation();

  const isCustomComponent = !('icon' in props.item);
  if (isCustomComponent) {
    return <div className="flex max-h-[2.25rem] items-center justify-center">{props.item.component}</div>;
  }

  // Determine the component type
  let Component: ElementType;
  if (isValidElement(props.item.component)) {
    Component = props.item.component;
  } else if (props.item?.action) {
    Component = 'button';
  } else if (props.item?.url) {
    Component = 'a';
  } else {
    Component = props.as;
  }

  const handleClick = () => {
    props.item.action?.();
    setState((prevState) => ({ ...prevState, showMobileMenu: false }));
  };

  const componentProps = {
    button: {
      type: 'button' as const,
      onClick: handleClick,
    },
    a: {
      href: props.item.url,
      rel: 'noopener noreferrer',
      target: props.item.target || '_blank',
    },
    Link: {
      href: getRelativeUrl(props.item.url),
      target: props.item.target || '_self',
      onClick: handleClick,
    },
  };

  const { icon, name, className, ...restProps } = props;
  const specificProps = componentProps[Component as keyof typeof componentProps] || {};

  return (
    <Component className={cx('stihl-text-body-xs-reg', styles.metaNavItem, className)} {...specificProps} {...restProps}>
      {icon && <img className="h-4 w-4" src={icon} alt={`${name} Icon`} />}
      <span>{name}</span>
    </Component>
  );
};
